import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram } from "lucide-react";
import footerLogo from "../assets/tolsol-logo-footer.png";

const Footer = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer className="bg-[#0A192F] py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-12">
          <div className="md:col-span-2">
            <img src={footerLogo} alt="TOLSOL Toldos y Lonas" className="h-16 w-auto mb-4 object-contain" />
            <p className="text-[#F2F2F2]/70 leading-relaxed max-w-md">
              Más de 30 años fabricando e instalando soluciones de protección solar de alta calidad en toda España.
            </p>
          </div>

          <div>
            <h3 className="text-[#F2F2F2] font-bold text-lg mb-4">Enlaces rápidos</h3>
            <ul className="space-y-2">
              <li>
                <button
                  onClick={() => scrollToSection("inicio")}
                  className="text-[#F2F2F2]/70 hover:text-[#FFD700] transition-colors"
                >
                  Inicio
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("nosotros")}
                  className="text-[#F2F2F2]/70 hover:text-[#FFD700] transition-colors"
                >
                  Nosotros
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("servicios")}
                  className="text-[#F2F2F2]/70 hover:text-[#FFD700] transition-colors"
                >
                  Servicios
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("blog")}
                  className="text-[#F2F2F2]/70 hover:text-[#FFD700] transition-colors"
                >
                  Blog
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection("contacto")}
                  className="text-[#F2F2F2]/70 hover:text-[#FFD700] transition-colors"
                >
                  Contacto
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-[#F2F2F2] font-bold text-lg mb-4">Conócenos</h3>
            <ul className="space-y-2 text-[#F2F2F2]/70">
              <li>
                <Link to="/politica-privacidad" className="hover:text-[#FFD700] transition-colors">
                  Política de privacidad
                </Link>
              </li>
              <li>
                <Link to="/politica-cookies" className="hover:text-[#FFD700] transition-colors">
                  Política de cookies
                </Link>
              </li>
              <li>
                <Link to="/aviso-legal" className="hover:text-[#FFD700] transition-colors">
                  Aviso legal
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#F2F2F2]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-[#F2F2F2]/60 text-sm">© 2025 TOLSOL. Todos los derechos reservados.</p>
            <div className="flex gap-4">
              <a
                href="https://www.instagram.com/tolsol_madrid?igsh=NzBlc2dzMjBmc28="
                target="_blank"
                rel="noreferrer"
                className="w-10 h-10 bg-[#F2F2F2]/10 rounded-full flex items-center justify-center hover:bg-[#FFD700] transition-colors group"
              >
                <Instagram className="w-5 h-5 text-[#F2F2F2] group-hover:text-[#0A192F]" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
